import type { ComponentPropsWithoutRef, ElementRef } from 'react'
import { forwardRef } from 'react'
import { Text as RNText, TextInput, View } from 'react-native'

import { colors } from '@/constants/colors'
import { cn } from '@/ui/utils'
import { inputStyles } from './input.styles'

type InputProps = ComponentPropsWithoutRef<typeof TextInput> & {
	/** Shown under the field in red, and turns the field's hairline red with it. */
	errorText?: string
}

const Input = forwardRef<ElementRef<typeof TextInput>, InputProps>(
	(
		{
			className,
			placeholderClassName,
			editable = true,
			placeholderTextColor = colors.muted,
			value,
			onChangeText,
			errorText,
			...props
		},
		ref
	) => {
		const { container, input, placeholder, error } = inputStyles()
		const invalid = !!errorText

		return (
			<View className={cn(container(), className)}>
				<TextInput
					ref={ref}
					className={cn(input({ editable, invalid }))}
					placeholderClassName={cn(placeholder())}
					placeholderTextColor={placeholderTextColor}
					value={value}
					onChangeText={onChangeText}
					{...props}
				/>
				{!!errorText && <RNText className={error()}>{errorText}</RNText>}
			</View>
		)
	}
)

Input.displayName = 'Input'

export { Input }
